// This page is currently a mini-app inject within the Rails page
// In the future, this component can take over the full page load

import React, { Suspense } from 'react';
import PropTypes from 'prop-types';
import { NetworkErrorBoundary, useResource } from 'rest-hooks';
import { Provider } from 'react-redux';
import { ToastContainer } from 'react-toastify';
import { StyledToast } from '@contently/toolkit';
import store from '../store/storeConfig';
import StoryResource from '../resources/StoryResource';
import { StoryContext } from '../hooks/useStoryContext';
import ErrorBoundary from './ErrorBoundary';
import LoadingSpinner from '../../utils/shared/LoadingSpinner';
import UserProvider from './UserProvider';
import ErrorRouter from './ErrorRouter';
import {YWebsocketContext} from "../hooks/useYWebsocketContext";

export default function ShowPageWrapper({ children, storyId, yWebsocketUrl, jwt }) {
  const story = useResource(StoryResource.detailShape(), { id: storyId });

  return (
    <StoryContext.Provider value={story}>
      <YWebsocketContext.Provider value={{ url: yWebsocketUrl, jwt: jwt}}>
        <Provider store={store}>
          <NetworkErrorBoundary fallbackComponent={ErrorRouter}>
            <Suspense fallback={<LoadingSpinner />}>
              <ErrorBoundary>
                <StyledToast>
                  <ToastContainer
                    icon={false}
                    position="top-center"
                    pauseOnFocusLoss={false}
                    autoClose={10000}
                  />
                </StyledToast>
                <UserProvider>{children}</UserProvider>
              </ErrorBoundary>
            </Suspense>
          </NetworkErrorBoundary>
        </Provider>
      </YWebsocketContext.Provider>
    </StoryContext.Provider>
  );
}

ShowPageWrapper.propTypes = {
  children: PropTypes.element.isRequired,
  storyId: PropTypes.number.isRequired
};



// WEBPACK FOOTER //
// ./app/javascript/client/components/ShowPageWrapper.jsx